import { FC } from "react";
import CardBody from "./card-body";
import CardImage from "./card-image";
import { twMerge } from "tailwind-merge";
import { ICard } from "./types";

const HalfListCard: FC<ICard & { href: string }> = (props) => {
  return (
    <div
      className={twMerge(
        "rounded-8 border  border-fds-cart hover:shadow-brand-md sm:p-4     flex "
      )}
    >
      <CardImage
        svg_image={props.svg_image}
        png_image={props.png_image}
        webp_image={props.webp_image}
        svg_featured_image={props.svg_featured_image}
        png_featured_image={props.png_featured_image}
        webp_featured_image={props.webp_featured_image}
        type={props.type}
        slug={props.slug}
        sku={props.sku}
        variant={props.variant}
        isFavorite={props.isFavorite}
        id={props.id}
        title={props.title_short || props.title}
        festival={props.festival}
        changeFavorite={props.changeFavorite}
      />
      <CardBody {...props} />
    </div>
  );
};
export default HalfListCard;
